<template>
  <div class="personal" style="width:900px;">
      <el-row :gutter="20" style="">
        <el-col :span="3" style="text-align:right;">
             <el-dropdown  @command="dropdownRouter">
                <span class="el-dropdown-link">
                    <img style="border-radius: 50%;width:90px;height:90px;" :src="'http://crm.joannarealestate.com.cn'+personal.Pic" alt="">
                </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="goUser">编辑个人资料</el-dropdown-item>
                        <el-dropdown-item command="layOut">退出</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
        </el-col>
        <el-col :span="17">
            <p class="ownerName">{{personal.NickName}}</p>
            <p>您拥有的房屋资产 · <span style="color:#59A3FA;">{{houseCount}}</span></p>
        </el-col>
        <el-col :span="4">
            <div class="top">
                <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                    <el-button type="primary" @click="goRouter" circle><i class="iconfont icon-bianji"></i></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="浏览" placement="top">
                     <el-button type="primary" circle><i class="iconfont icon-yonghu"></i></el-button>
                </el-tooltip>
            </div>
        </el-col>
      </el-row>
  </div>
</template>
<script>
export default {
    props:[
        'activeName'
    ],
    data() {
        return {
           personal:{

           },
           houseCount: 0,
           falg: 'third'
        }
    },

    methods: {
        getOwner(){
            this.$get('/Handler/FYGL.ashx',{Action:'GetNegotiator',},(data)=>{
                
                this.personal = data[0];
                // window.localStorage.setItem('ownerInfor',this.personal)
            },(err)=>{

            });
        },
        dropdownRouter(event){
            if(event == 'goUser'){
                this.goRouter();
            }else if(event == 'layOut'){
                this.signOut();
            }
        },
        getOwnerHouseCount(){
            //获取房源数量
            var params = {
                Action: 'InitFYCount1'
            }
            this.$get('/Handler/FYGL.ashx',params,(data)=>{
                this.houseCount = data;
            },(err)=>{

            });
        },
        goRouter(){
            this.changeName();
            this.$router.push({path:'/controlPanel',query:{tab:'third'}});
        },
        changeName(){
            this.$emit('update:activeName','third');
        },
        signOut(){
            this.$router.push({path:'/'});
            window.localStorage.removeItem('JRE_MESSAGE');
        }
    },
    created() {
        this.getOwner()
        this.getOwnerHouseCount();
        
    }
}
</script>
<style scoped>
.ownerName{
    margin-top: 20px;
}
.top{
    margin-top: 20px;
}
</style>




// WEBPACK FOOTER //
// src/components/personal/personal.vue